import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import MantineText from '../mantine/text';

const PhoneInputWithCountry2 = (props: any) => {
    const { placeholder, value, onChange, error, inputClass, dropdownClass, containerClass, parentClassName } = props;
    return (
        <div className={`relative ${parentClassName}`}>
            <MantineText className="text-sm font-medium text-[14px]" name={"Phone Number"} />
            <PhoneInput
                country={'in'}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                inputClass={inputClass}
                enableSearch={true}
                containerClass={containerClass}
                searchPlaceholder={"Search by Country"}
                searchNotFound={"No Data Found"}
                masks={{ in: '..........' }}
                buttonStyle={{
                    border: "1px solid var(--current-secondary-color)",
                    backgroundColor: "var(--current-territory-color)",
                    transition: "background-color 0.2s",
                }}
                dropdownClass={`border border-current-secondary-color shadow-md rounded-md p-1 mt-1 max-h-48 overflow-y-auto divide-y divide-gray-200 hover:bg-current-territory-color focus:outline-none focus:ring-1 focus:ring-current-primary-color focus:border-current-primary-color ${dropdownClass}`}

            />
            {error && (
                <MantineText className="text-[12px] text-red-500" name={error} />
            )}
        </div>
    );
};

export default PhoneInputWithCountry2;
